import Page from '@/components/common/page';
import { forEachNode } from '../../utils/forEachNode'
// import OurTeam from './our-team';

class AboutPage extends Page {
    init() {
        // this.ourTeam = new OurTeam;
        const elements = document.querySelectorAll('.contacts__branch-name')
        forEachNode(elements, el=>el.addEventListener('click', this.toggleBranch))

    }

    toggleBranch(event) {
        const blocks = document.querySelectorAll('.contacts__cards')
        const dataId = event.target.getAttribute('data-id')
        const selector = '#contacts_'+dataId
        forEachNode(blocks, block => block.classList.add('contacts__cards_hidden'))
        document.querySelector(selector).classList.remove('contacts__cards_hidden')

        const selectors = document.querySelectorAll('.contacts__branch-name')
        forEachNode(selectors, block => block.classList.remove('contacts__branch-toggle'))
        const selector2 = "p[data-id='"+dataId+"']"
        document.querySelector(selector2)?.classList.add('contacts__branch-toggle')
    }
}

export default AboutPage;
